<template>
    <Tag :color="color">
        {{text}}
    </Tag>
</template>

<script>
    /**
     * 帐号启用状态
     */
    export default {
        name: 'LyUseStatus',  
        props: {
            value: {
                type: [String, Number, Boolean],
                default: ''
            }
        },
        data () {
            return {
                color: 'error'
            }
        },
        computed: {
            text () {
                let str = '停用'
                switch (this.value) {
                    case 0:
                        str = '停用'
                        this.color = 'error'
                    break;
                    case 1:
                        str = '启用'
                        this.color = 'success'
                    break;
                    case 2:
                        str = '禁用'
                        this.color = 'error'
                    break;
                    case 3:
                        str = '未设置'
                        this.color = 'default'
                }
                return str
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ../projectCore/src/components/use-status/src/index.vue